import type { ReactNode } from 'react';

import styles from './device-switcher.component.module.scss';

type Props = {
  desktop: ReactNode;
  mobile: ReactNode;
};

// todo:
// レイアウト（padding）の取り方をデスクトップとモバイルで統一する
// デスクトップ：ナビゲーションアイテムのpaddingで調整している
// モバイル：ラッパーで規定のpaddingを取っている
// memo:
// ロゴのちらつ気をなくすため、ロゴは当コンポーネントに組み込んでも良いかもしれない
export const DeviceSwitcher = ({ desktop, mobile }: Props) => {
  return (
    <div className={styles.deviceSwitcher}>
      <div className={`desktop_header ${styles.desktopWrapper}`}>{desktop}</div>
      <div className={`mobile_header ${styles.mobileWrapper}`}>{mobile}</div>
    </div>
  );
};
